import { ensureAuthenticatedUser, AbortError } from '@forest/paywall-core'
import { getReceiptSystemAccountIdSafe, native } from '@forest/native-services'
import { appVersion } from '~/params'
import { closeButton } from '~/store/close-button'
import { $receiptSystemAccountId } from '~/store/receipt-system-account-id'
import { $userInfo } from '~/store/user-info'
import type { UserInfo } from '@forest/native-services'

export { AbortError }

export async function getAuthenticatedUserInfo(): Promise<UserInfo> {
  return ensureAuthenticatedUser({
    getUserInfo: () =>
      native.user.getUserInfo().then((result) => {
        if (!result.success) return result
        if (!result.data) throw new Error('getUserInfo returned null')
        return { success: true as const, data: result.data }
      }),
    auth: () => native.auth.auth(),
    bindLegacyUser: () => native.auth.bindLegacyUser(),
    onAfterGuestUpgrade: async () => {
      $receiptSystemAccountId.set(
        await getReceiptSystemAccountIdSafe(appVersion),
      )
    },
    onLegacyBindStart: () => closeButton.hide(),
    onLegacyBindEnd: () => closeButton.show(),
    onUserInfo: (userInfo) => {
      $userInfo.set(userInfo)
    },
  })
}
